import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomBrands = createSvgIcon(
  <path d="m18.056 11.622-5.684-5.684a1.3 1.3 0 0 0-.908-.373H6.85c-.709 0-1.288.58-1.288 1.287v4.615c0 .341.135.67.38.908l5.684 5.683a1.29 1.29 0 0 0 1.821 0l4.615-4.615a1.284 1.284 0 0 0-.006-1.821m-9.315-.333c-.534 0-1.248-1.056-1.248-1.59 0-.535 1.669-2.203 2.203-2.203s1.59.696 1.59 1.23-2.01 2.563-2.545 2.563" />,
  'CustomBrands',
);

export default CustomBrands;
